export function getToken() {
  // 使用 accessToken 进行日常请求认证
    return localStorage.getItem('token')
}

export function setToken(token) {
  return localStorage.setItem('token', token)
}

export function removeToken() {
  return localStorage.removeItem('token')
}